import React, { useState, useEffect, Suspense } from '/web_modules/react.js';
import styled, { createGlobalStyle } from '/web_modules/styled-components.js';
import { cssReset } from './cssReset.js';
import { Header } from './Header.js';
import { motion, AnimatePresence } from '/web_modules/framer-motion.js';
import { queryCache } from '/web_modules/react-query.js';
import { lazyWithPreload } from './util.js';
import { Spinner } from './Spinner.js';
import { getRankings } from './getRankings.js';
import PlayView from './Play.js';
export const GlobalStyles = createGlobalStyle`
    ${cssReset}
    body {
        font-family: "Overpass", "Arial", sans-serif;
    }

    a {
      :focus {
        color: red;
      }
    }

    h1 {
    }
`;
const ViewContainer = styled(motion.div).withConfig({
  displayName: "App__ViewContainer",
  componentId: "sc-22p06t-0"
})(["width:100%;"]);
const Wrap = styled.div.withConfig({
  displayName: "App__Wrap",
  componentId: "sc-22p06t-1"
})(["display:flex;min-height:100vh;display:flex;justify-content:center;", "{margin-bottom:32px;}> div{max-width:860px;display:flex;flex-direction:column;flex-grow:1;> div{position:relative;}}"], Header);

function App() {
  const [currentView, setCurrentView] = useState('play');
  useEffect(() => {
    queryCache.prefetchQuery('rankings', getRankings);
  }, []);
  const RankingsView = lazyWithPreload(() => import("./RankingsView.js"));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyles, null), /*#__PURE__*/React.createElement(Wrap, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Header, {
    activeView: currentView,
    onViewChange: setCurrentView
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AnimatePresence, {
    initial: false
  }, currentView === 'play' && /*#__PURE__*/React.createElement(ViewContainer, {
    initial: {
      x: '-10px',
      opacity: 0
    },
    animate: {
      x: 0,
      opacity: 1
    },
    exit: {
      x: '-10px',
      position: 'absolute',
      opacity: 0
    },
    key: 'playView'
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Spinner, null)
  }, /*#__PURE__*/React.createElement(PlayView, null))), currentView === 'rankings' && /*#__PURE__*/React.createElement(ViewContainer, {
    initial: {
      x: '10px',
      opacity: 0
    },
    animate: {
      x: 0,
      opacity: 1
    },
    exit: {
      x: '10px',
      position: 'absolute',
      opacity: 0
    },
    key: 'rankingsView'
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Spinner, null)
  }, /*#__PURE__*/React.createElement(RankingsView, null))))))));
}

export default App;